import React from 'react';
import { HiArrowRight } from 'react-icons/hi2';

const LeftArrowIcon = ({ className = "", disabled = false }) => (
  <HiArrowRight 
    className={`inline-block rotate-180 ${className}`}
    style={{ color: disabled ? '#b4c1cf' : '#0078d2' }}
    size={16}
  />
);

const RightArrowIcon = ({ className = "", disabled = false }) => (
  <HiArrowRight 
    className={`inline-block ${className}`}
    style={{ color: disabled ? '#b4c1cf' : '#0078d2' }}
    size={16}
  />
);

const CarouselArrows = ({ 
  onPrevious, 
  onNext, 
  canGoPrevious = true, 
  canGoNext = true,
  className = "",
  show = true 
}) => {
  if (!show) {
    return null;
  }

  return (
    <div className={`inline-flex items-center bg-white rounded-md ${className}`}>
      <button
        title="scroll left"
        onClick={onPrevious}
        disabled={!canGoPrevious}
        className={`
          flex items-center justify-center appearance-none border-0 bg-transparent 
          leading-none p-2 font-inherit text-base
          ${!canGoPrevious ? 'cursor-not-allowed' : 'cursor-pointer'}
        `}
      >
        <span className="flex items-center justify-center">
          <LeftArrowIcon disabled={!canGoPrevious} />
        </span>
      </button>
      
      <button
        title="scroll right"
        onClick={onNext}
        disabled={!canGoNext}
        className={`
          flex items-center justify-center appearance-none border-0 bg-transparent 
          leading-none p-2 font-inherit text-base
          ${!canGoNext ? 'cursor-not-allowed' : 'cursor-pointer'}
        `}
      >
        <span className="flex items-center justify-center">
          <RightArrowIcon disabled={!canGoNext} />
        </span>
      </button>
    </div>
  );
};

export default CarouselArrows;